import React from 'react';
import PropTypes from 'prop-types';
import { TIME_RANGE_QUICK, TIME_RANGE_ABSOLUTE } from '../../Constants';
import { PRIMARY_COLOR, PRIMARY_COLOR_HIGHLIGHT } from '../../../colors';
import { colorsModeUI } from '../../../modeUI';
import polyglotUIComponents from '../../../i18n';
import './index.css';

/**
 * Time range selection panel
 * Parameters (Props):
 * @param toogleTimeRange: PropTypes.func.isRequired
 * @param timeRange: PropTypes.number.isRequired
 */
export default class TimeRangeSelectionPanel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.toggleHoverTimeRange = this.toggleHoverTimeRange.bind(this);
    this.polyglot = polyglotUIComponents(props.language);
    this.state = {
      hoverTimeRange: {
        [TIME_RANGE_QUICK]: false,
        [TIME_RANGE_ABSOLUTE]: false,
      },
    };
  }

  /**
   * Toogle hover time range
   * @param int timeRange
   */
  toggleHoverTimeRange(timeRange) {
    const { hoverTimeRange } = this.state;
    hoverTimeRange[timeRange] = !hoverTimeRange[timeRange];
    this.setState({
      hoverTimeRange: {
        [TIME_RANGE_QUICK]: hoverTimeRange[TIME_RANGE_QUICK],
        [TIME_RANGE_ABSOLUTE]: hoverTimeRange[TIME_RANGE_ABSOLUTE],
      },
    });
  }

  render() {
    const { hoverTimeRange } = this.state;
    const { toogleTimeRange, timeRange, mode } = this.props;
    const styleButtonHover = { fontWeight: 'bold' };
    const styleButtonActive = { color: PRIMARY_COLOR_HIGHLIGHT };
    const styleButton = { color: PRIMARY_COLOR };
    const style = {};
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      styleButton.color = modeColors.TEXT_COLOR;
      styleButtonActive.color = modeColors.TEXT_COLOR;
      styleButtonActive.fontWeight = 'bold';
      style.backgroundColor = modeColors.POPUP_MAIN_MENU_BACKGROUND;
      style.color = modeColors.POPUP_MAIN_MENU_COLOR;
    }
    return (
      <div className="timeframe-selection-panel" style={style}>
        <div>
          {`${this.polyglot.t('timeframe_selection_panel.time_range')}:   `}
        </div>
        <div>
          <button
            className="time-range"
            type="button"
            style={{
              ...(timeRange === TIME_RANGE_QUICK
                ? styleButtonActive
                : styleButton),
              ...(hoverTimeRange[TIME_RANGE_QUICK] ? styleButtonHover : {}),
            }}
            onClick={() => toogleTimeRange(TIME_RANGE_QUICK)}
            onMouseEnter={() => this.toggleHoverTimeRange(TIME_RANGE_QUICK)}
            onMouseLeave={() => this.toggleHoverTimeRange(TIME_RANGE_QUICK)}
          >
            {this.polyglot.t('timeframe_selection_panel.quick')}
          </button>
        </div>
        <div>
          <button
            className="time-range"
            type="button"
            style={{
              ...(timeRange === TIME_RANGE_ABSOLUTE
                ? styleButtonActive
                : styleButton),
              ...(hoverTimeRange[TIME_RANGE_ABSOLUTE] ? styleButtonHover : {}),
            }}
            onClick={() => toogleTimeRange(TIME_RANGE_ABSOLUTE)}
            onMouseEnter={() => this.toggleHoverTimeRange(TIME_RANGE_ABSOLUTE)}
            onMouseLeave={() => this.toggleHoverTimeRange(TIME_RANGE_ABSOLUTE)}
          >
            {this.polyglot.t('timeframe_selection_panel.absolute')}
          </button>
        </div>
      </div>
      /* <Grid.Row verticalAlign="middle" className="timeframe-selection-panel">
        <Grid.Column verticalAlign="middle">
          <Header as="h5">
            {`${polyglotUIComponents.t('timeframe_selection_panel.time_range')}:   `}
            <button
              className="time-range"
              type="button"
              style={
                {
                  ...timeRange === TIME_RANGE_QUICK ? styleButtonActive : styleButton,
                  ...hoverTimeRange[TIME_RANGE_QUICK] ? styleButtonHover : {},
                }
              }
              onClick={() => toogleTimeRange(TIME_RANGE_QUICK)}
              onMouseEnter={() => this.toggleHoverTimeRange(TIME_RANGE_QUICK)}
              onMouseLeave={() => this.toggleHoverTimeRange(TIME_RANGE_QUICK)}
            >
              {polyglotUIComponents.t('timeframe_selection_panel.quick')}
            </button>
            <button
              className="time-range"
              type="button"
              style={
                {
                  ...timeRange === TIME_RANGE_ABSOLUTE ? styleButtonActive : styleButton,
                  ...hoverTimeRange[TIME_RANGE_ABSOLUTE] ? styleButtonHover : {},
                }
              }

              onClick={() => toogleTimeRange(TIME_RANGE_ABSOLUTE)}
              onMouseEnter={() => this.toggleHoverTimeRange(TIME_RANGE_ABSOLUTE)}
              onMouseLeave={() => this.toggleHoverTimeRange(TIME_RANGE_ABSOLUTE)}
            >
              {polyglotUIComponents.t('timeframe_selection_panel.absolute')}
            </button>
          </Header>
        </Grid.Column>
      </Grid.Row> */
    );
  }
}

TimeRangeSelectionPanel.propTypes = {
  toogleTimeRange: PropTypes.func.isRequired,
  timeRange: PropTypes.number.isRequired,
  mode: PropTypes.string,
  language: PropTypes.string,
};

TimeRangeSelectionPanel.defaultProps = {
  mode: null,
  language: null,
};
